/**************************************************
 * Nombre:       Formulario_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, Flag, Google, LocalOfferOutlined} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {useEffect, useState} from "react";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import {ESTADOSUSUARIOS} from "../../Constantes";

const Formulario_Sub_Categoria = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid2
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >



                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoSelect Icono={LocalOfferOutlined} nombre={'Nombre de la sub categoria'} dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'} opciones={props.opciones}
                    />
                </Grid2>


            </Grid2>

        </form>

    )

}
export default Formulario_Sub_Categoria